export const NBA_HEADER_COPY = {
  eyebrow: "Sports Hub • Basketball",
  title: "NBA Terminal",
  description: "Track live NBA games, monitor AI predictions, and stay close to league action worldwide.",
};
